import type { IntelSection } from '../../lib/intel';

/**
 * Sample Threat Intel: three invented sections, one per kind of source, written for the demo (client notes 10/26, Threat
 * Intel 3). The items are not in severity order on purpose: the panel ranks them. Nothing here comes from a real feed, and
 * the panel says so.
 */
export const C3_INTEL_SECTIONS: IntelSection[] = [
  {
    name: 'Government advisories',
    items: [
      {
        id: 'gov-1',
        severity: 'medium',
        title: 'Exposed build artefacts in public storage',
        detail: 'Storage left open to the internet is leaking build outputs with embedded keys. Check public buckets.',
        minutesAgo: 1180,
      },
      {
        id: 'gov-2',
        severity: 'critical',
        title: 'Remote-access gateways exploited without credentials',
        detail: 'An authentication flaw lets an attacker in with no credentials. Patch, or take the gateway off the internet.',
        minutesAgo: 95,
        incident: 'INC-4021',
      },
      {
        id: 'gov-3',
        severity: 'low',
        title: 'Look-alike file-sharing pages used in phishing',
        detail: 'Pages that copy a trusted sharing service collect sign-ins. No exploit involved.',
        minutesAgo: 2600,
      },
      {
        id: 'gov-4',
        severity: 'high',
        title: 'Ransomware group goes after backup consoles',
        detail: 'Backup management consoles reachable from the network are encrypted first. Isolate and review access.',
        minutesAgo: 310,
      },
    ],
  },
  {
    name: 'Community threat exchange',
    items: [
      {
        id: 'com-1',
        severity: 'high',
        title: 'Credential-stealing campaign aimed at cloud administrators',
        detail: 'Sign-in prompts lead to session theft, then policy changes made from the stolen session.',
        minutesAgo: 40,
        incident: 'INC-4025',
      },
      {
        id: 'com-2',
        severity: 'low',
        title: 'Scanning of an old identity-provider endpoint',
        detail: 'Broad, low-volume scanning with no sign of a working exploit.',
        minutesAgo: 780,
      },
      {
        id: 'com-3',
        severity: 'critical',
        title: 'Command-and-control addresses tied to a known intrusion set',
        detail: 'Eleven addresses used for beaconing from compromised laptops. Block and look for past contact.',
        minutesAgo: 150,
      },
      {
        id: 'com-4',
        severity: 'medium',
        title: 'New wave of token-theft browser extensions',
        detail: 'Extensions posing as productivity tools read session tokens from the browser.',
        minutesAgo: 420,
      },
    ],
  },
  {
    name: 'Malware and phishing feeds',
    items: [
      {
        id: 'mal-1',
        severity: 'medium',
        title: 'Look-alike sign-in pages for single sign-on portals',
        detail: 'Newly registered domains copy the portals of three identity providers.',
        minutesAgo: 65,
      },
      {
        id: 'mal-2',
        severity: 'critical',
        title: 'Wiper sample circulating against data stores',
        detail: 'Overwrites object storage and database volumes after gaining a cloud role.',
        minutesAgo: 230,
        incident: 'INC-4030',
      },
      {
        id: 'mal-3',
        severity: 'high',
        title: 'Loader delivered through poisoned search results',
        detail: 'Fake installers for admin tools drop a loader that opens a remote session.',
        minutesAgo: 510,
      },
      {
        id: 'mal-4',
        severity: 'low',
        title: 'Adware bundled with a screen-capture utility',
        detail: 'Nuisance software; no credential access seen.',
        minutesAgo: 3100,
      },
    ],
  },
];
